(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;
  const el = U.el;
  const esc = U.esc;
  const dispatch = U.dispatch;
  const live = U.live;
  const animBusy = U.animBusy;

  function seatName(state, p) {
    const pl = state.players[p];
    const legend = pl.legendIid ? Core.card(state, pl.legendIid) : null;
    return legend && legend.name ? legend.name : pl.name;
  }

  function localHuman(pd) {
    if (!pd || pd.player === undefined) return false;
    if (APP.ai[pd.player]) return false;
    if (APP.net && pd.player !== APP.seat) return false;
    return true;
  }

  function stepText(pd) {
    return pd.step ? "Step " + pd.step.n + " of " + pd.step.of + ": " : "";
  }

  function arenaStatus(state) {
    const pd = state.pending;
    if (state.over) return { text: esc(seatName(state, state.over.winner)) + " wins", cls: "over" };
    if (!live()) return { text: "Replay", cls: "wait" };
    if (!pd || animBusy()) return { text: "Resolving", cls: "wait" };
    if (!localHuman(pd)) return { text: "Waiting", cls: "wait" };
    if (APP.holdPass) return { text: "Holding · pass", cls: "hold" };
    if (pd.kind === "act") return { text: "Your move", cls: "mine" };
    if (pd.kind === "focus" || pd.kind === "respond") return { text: "Respond", cls: "mine" };
    if (pd.kind === "mulligan") return { text: "Mulligan", cls: "mine" };
    if (pd.kind === "pay") return { text: "Pay", cls: "mine" };
    if (pd.kind === "assign") return { text: "Assign", cls: "mine" };
    if (pd.kind === "manual") return { text: "Manual", cls: "mine" };
    return { text: "Choose", cls: "mine" };
  }

  function arenaTurnButton(state) {
    const pd = state.pending;
    if (state.over || !live() || animBusy() || !localHuman(pd)) return null;
    const box = el("div", "arturnbtn");
    if (pd.kind === "act") {
      const b = el("button", "btn primary", "End Turn");
      b.onclick = function (ev) { ev.stopPropagation(); dispatch({ type: "END_TURN", player: pd.player }); };
      box.appendChild(b);
    } else if (pd.kind === "focus" || pd.kind === "respond") {
      const b = el("button", "btn primary", "Pass");
      b.onclick = function (ev) { ev.stopPropagation(); dispatch({ type: "PASS", player: pd.player }); };
      box.appendChild(b);
    } else if (pd.kind === "mulligan") {
      const b = el("button", "btn primary", "Keep hand" + (APP.picked.length ? " · recycle " + APP.picked.length : ""));
      b.onclick = function (ev) { ev.stopPropagation(); dispatch({ type: "MULLIGAN", player: pd.player, cards: APP.picked.slice() }); };
      box.appendChild(b);
    } else if (pd.kind === "manual") {
      if (!APP.showManual) {
        const pal = el("button", "btn", "Palette");
        pal.onclick = function (ev) { ev.stopPropagation(); U.setShowManual(true); };
        box.appendChild(pal);
      }
      const b = el("button", "btn primary", "Continue");
      b.onclick = function (ev) { ev.stopPropagation(); dispatch({ type: "CONTINUE", player: pd.player }); };
      box.appendChild(b);
    } else {
      return null;
    }
    return box;
  }

  function predictPanel(state, pd) {
    const reveal = el("div", "predictreveal");
    const top = state.players[pd.player].mainDeck[0];
    const c = top ? Core.card(state, top) : null;
    if (c) {
      const img = document.createElement("img");
      RB.artSrc(img, c, "140px");
      RB.artFallback(img, c);
      reveal.appendChild(img);
    }
    const col = el("div", "pcol");
    col.appendChild(el("div", "pname", esc(c ? c.name : "Top card")));
    if (c && c.text) col.appendChild(el("div", "ptext", U.fmtText(c.text)));
    col.appendChild(el("div", "note", "The top card of your deck. Keep it there, or recycle it away."));
    const row = el("div", "actions");
    const keep = el("button", "btn primary", U.fmtText(pd.options[1] || "Keep on top"));
    keep.onclick = function () { dispatch({ type: "CHOOSE", player: pd.player, optionIdx: 1 }); };
    row.appendChild(keep);
    const rec = el("button", "btn", U.fmtText(pd.options[0] || "Recycle"));
    rec.onclick = function () { dispatch({ type: "CHOOSE", player: pd.player, optionIdx: 0 }); };
    row.appendChild(rec);
    col.appendChild(row);
    reveal.appendChild(col);
    return reveal;
  }

  function arenaOverlay(state) {
    const pd = state.pending;
    if (state.over || !live() || animBusy() || !localHuman(pd)) return null;
    const panel = el("div", "arpanel");
    if (pd.kind === "pay") {
      if (U.autoPayable(state)) return null;
      panel.appendChild(U.renderPay(state, pd));
    } else if (pd.kind === "assign") {
      const actions = el("div", "actions");
      panel.appendChild(U.renderAssign(state, pd, actions));
      panel.appendChild(actions);
    } else if (pd.kind === "choose" && pd.split) {
      panel.appendChild(el("h3", null, U.fmtText((pd.src ? pd.src + " — " : "") + stepText(pd) + (pd.prompt || "Split"))));
      if (pd.hint) panel.appendChild(el("span", "note", U.fmtText(pd.hint)));
      panel.appendChild(U.renderSplit(state, pd));
    } else if (pd.kind === "choose" && pd.tag === "predict" && pd.options) {
      panel.appendChild(el("h3", null, "Vision"));
      panel.appendChild(predictPanel(state, pd));
    } else {
      return null;
    }
    const ov = el("div", "aroverlay");
    ov.appendChild(panel);
    return ov;
  }

  function promptSourceIid(state, pd) {
    if (pd.srcIid !== undefined && pd.srcIid !== null) return pd.srcIid;
    if (!pd.src) return null;
    const item = state.chain.find(function (it) { return it.label === pd.src; });
    if (!item) return null;
    return item.iid !== undefined && item.iid !== null ? item.iid : item.source;
  }

  function positionBand(m) {
    const base = document.querySelector("#arena .arbase.mine");
    const br = base && base.getBoundingClientRect();
    if (!br || !br.height) return;
    let handTop = Infinity;
    const slots = document.querySelectorAll("#arena .arhand.mine .arslot");
    for (let i = 0; i < slots.length; i++) {
      const r = slots[i].getBoundingClientRect();
      if (r.height && r.top < handTop) handTop = r.top;
    }
    if (!isFinite(handTop)) handTop = br.bottom + 40;
    const mr = m.getBoundingClientRect();
    const s = parseFloat(getComputedStyle(document.getElementById("arena")).getPropertyValue("--s")) || 1;
    let top = br.bottom - 36 * s;
    if (top + mr.height > handTop + (window.innerHeight - handTop) * .7) top = Math.min(top, handTop - mr.height * .35);
    top = Math.max(8, Math.min(top, window.innerHeight - mr.height - 8));
    m.style.transform = "none";
    m.style.top = Math.round(top) + "px";
    m.style.left = Math.round((window.innerWidth - mr.width) / 2) + "px";
  }

  function positionChoiceMenu(state) {
    if (typeof document === "undefined") return;
    const m = document.getElementById("choicemenu");
    const pd = state && state.pending;
    if (!m || !pd || !m.getBoundingClientRect) return;
    if (m.classList.contains("band")) { positionBand(m); return; }
    const iid = promptSourceIid(state, pd);
    if (iid === null || iid === undefined) return;
    const anchor = document.querySelector("[data-iid='" + iid + "']");
    const r = anchor && anchor.getBoundingClientRect && anchor.getBoundingClientRect();
    if (!r || (!r.width && !r.height)) return;
    m.style.transform = "none";
    U.placeFloating(m, r, { side: "right", pad: 14 });
    m.classList.add("anchored");
  }

  Object.assign(U, { seatName: seatName, arenaStatus: arenaStatus, arenaTurnButton: arenaTurnButton, arenaOverlay: arenaOverlay, positionChoiceMenu: positionChoiceMenu });
})();
